import axios from 'axios';
import store from '../store';
import { CreatePipelineRequest } from '@/models/PipelineSection/CreatePipelineRequest';
import { UpdatePipelineRequest } from '@/models/PipelineSection/UpdatePipelineRequest';

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_ROOT,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

let token = '';

export default {
  async getPipelineSections() {
    token = store.getters.token;

    return await apiClient.get('/pigrun/pipelinesections', {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  async createPipelineSection(request: CreatePipelineRequest) {
    token = store.getters.token;

    return await apiClient.post('/pigrun/pipelinesection', request, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  async updatePipelineSection(request: UpdatePipelineRequest) {
    token = store.getters.token;

    return await apiClient.put('/pigrun/pipelinesection', request, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  async deletePipelineSection(pipelineSectionId: number) {
    token = store.getters.token;

    return await apiClient.delete('/pigrun/pipelinesection', {
      headers: { Authorization: `Bearer ${token}` },
      data: { pipelineSectionId },
    });
  },
};
